import {
  VehicleForm,
  DamageType,
  OtherDamage,
  VictimForm,
  ClaimType,
} from 'containers/CourtManagerLegalProceedings/typings';

export const COURT_MANAGER_LEGAL_PROCEEDINGS = {
  RECAP: 0,
  JUDGEMENT_ADD: 1,
  EXPERT_REPORT: 2,
  JUDGEMENT_ON_MERITS: 3,
};

export const REQUEST_MAKE_JUDGEMENT_ADD_DECISION =
  'REQUEST_MAKE_JUDGEMENT_ADD_DECISION';
export const REQUEST_MAKE_JUDGEMENT_ADD_DOCUMENT_DECISION =
  'REQUEST_MAKE_JUDGEMENT_ADD_DOCUMENT_DECISION';
export const REQUEST_ASSIGNED_EXPERT = 'REQUEST_ASSIGNED_EXPERT';
export const REQUEST_UPDATE_CIVIL = 'REQUEST_UPDATE_CIVIL';
export const REQUEST_VALIDATE_CIVIL_PROCEEDING =
  'REQUEST_VALIDATE_CIVIL_PROCEEDING';
export const REQUEST_VALIDATE_EXPERT_REPORT = 'REQUEST_VALIDATE_EXPERT_REPORT';
export const REQUEST_VALIDATE_JUDGEMENT_ON_MERITS =
  'REQUEST_VALIDATE_JUDGEMENT_ON_MERITS';
export const REQUEST_VALIDATE_JUDGEMENT_APPEAL =
  'REQUEST_VALIDATE_JUDGEMENT_APPEAL';
export const rcCoporeal = 'RC - Dommages corporels causés aux tiers';
export const CREATE_CIVIL_PROCEEDING = 'CREATE_CIVIL_PROCEEDING';
export const REQUEST_VALIDATE_DISCLAIMER_WARRANTY =
  'REQUEST_VALIDATE_DISCLAIMER_WARRANTY';
export const REQUEST_VALIDATE_ADD_VICTIMS_CARD =
  'REQUEST_VALIDATE_ADD_VICTIMS_CARD';
export const REQUEST_CREATE_VEHICLES = 'REQUEST_CREATE_VEHICLES';
export const REQUEST_MAKE_DECISION_MISSION_EXPERTISE =
  'REQUEST_MAKE_DECISION_MISSION_EXPERTISE';
export const OTHER_PROPERTIES_DESCRIPTION_SIZE_LIMIT = 15;
export const REQUEST_MAKE_DECISION_MISSION_NOTICE_DEFICIENCY =
  'REQUEST_MAKE_DECISION_MISSION_NOTICE_DEFICIENCY';
export const REQUEST_GET_EXPERTS_USERS = 'REQUEST_GET_EXPERTS_USERS';
export const SET_EXPERTS_USERS = 'SET_EXPERTS_USERS';
export const REQUEST_ADD_APPRECIATION = 'REQUEST_ADD_APPRECIATION';
export const REQUEST_UPDATE_CIVIL_PROCEEDING =
  'REQUEST_UPDATE_CIVIL_PROCEEDING';
export const REQUEST_SET_IS_SUSPICIOS_CLAIM = 'REQUEST_SET_IS_SUSPICIOS_CLAIM';
export const CREATE_JUDGEMENT_ADD = 'CREATE_JUDGEMENT_ADD';
export const REQUEST_LOCK_CLAIM = 'REQUEST_LOCK_CLAIM';
export const REQUEST_UNLOCK_CLAIM = 'REQUEST_UNLOCK_CLAIM';
export const SET_LOCKED_CLAIM = 'SET_LOCKED_CLAIM';
export const MAKE_DECISION_DOCUMENT_IMAGING = 'MAKE_DECISION_DOCUMENT_IMAGING';
export const REQUEST_CHECK_CIVIL_PARTY_JUDICIARY_PROCESS =
  'REQUEST_CHECK_CIVIL_PARTY_JUDICIARY_PROCESS';
export const SET_CHECK_CIVIL_PARTY_JUDICIARY_PROCESS =
  'SET_CHECK_CIVIL_PARTY_JUDICIARY_PROCESS';
export const SET_DECISION_JUDGEMENT_IDS = 'SET_DECISION_JUDGEMENT_IDS';
export const REQUEST_GET_CLAIM_HISTORY_ACTIONS =
  'REQUEST_GET_CLAIM_HISTORY_ACTIONS';
export const SET_CLAIM_HISTORY_ACTIONS = 'SET_CLAIM_HISTORY_ACTIONS';
export const REQUEST_GET_CLAIM_HISTORY_SAGIS =
  'REQUEST_GET_CLAIM_HISTORY_SAGIS';
export const SET_CLAIM_HISTORY_SAGIS = 'SET_CLAIM_HISTORY_SAGIS';
export const REQUEST_SET_STATUS_CLAIM_SAGIS = 'REQUEST_SET_STATUS_CLAIM_SAGIS';
export const REQUEST_ADD_STAKE_HOLDER = 'REQUEST_ADD_STAKE_HOLDER';
export const REQUEST_UPDATE_PRIORITY_CLAIM_PROVISION =
  'REQUEST_UPDATE_PRIORITY_CLAIM_PROVISION';
export const REQUEST_GET_INSTRUCTIONS = 'REQUEST_GET_INSTRUCTIONS';
export const SET_INSTRUCTIONS = 'SET_INSTRUCTIONS';
export const REQUEST_CREATE_INSTRUCTIONS = 'REQUEST_CREATE_INSTRUCTIONS';
export const REQUEST_UPDATE_INSTRUCTIONS = 'REQUEST_UPDATE_INSTRUCTIONS';
export const REQUEST_RESET_HISTORY_STORE = 'REQUEST_RESET_HISTORY_STORE';
export const REQUEST_GET_CLAIM_CIVIL_PARTY = 'REQUEST_GET_CLAIM_CIVIL_PARTY';
export const SET_CLAIM_CIVIL_PARTY = 'SET_CLAIM_CIVIL_PARTY';
export const REQUEST_CREATE_INCOME_CERTIFICATE =
  'REQUEST_CREATE_INCOME_CERTIFICATE';
export const REQUEST_UPDATE_INCOME_CERTIFICATE =
  'REQUEST_UPDATE_INCOME_CERTIFICATE';
export const REQUEST_ARCHIVE_JUDGEMENT = 'REQUEST_ARCHIVE_JUDGEMENT';
export const REQUEST_MAKE_DECISION_INCOME_CERTIFICATE =
  'REQUEST_MAKE_DECISION_INCOME_CERTIFICATE';
export const REQUEST_MAKE_DECISION_SUPPORT_DOCUMENT =
  'REQUEST_MAKE_DECISION_SUPPORT_DOCUMENT';

export const REQUEST_GET_PENDING_TASKS_CLAIM =
  'REQUEST_GET_PENDING_TASKS_CLAIM';

export const REQUEST_UPLOAD_DOCUMENT_MANAGER =
  'REQUEST_UPLOAD_DOCUMENT_MANAGER';

export const REQUEST_GET_DECISION_FLOW_VICTIMS =
  'REQUEST_GET_DECISION_FLOW_VICTIMS';

export const SET_DECISION_FLOW_VICTIMS = 'SET_DECISION_FLOW_VICTIMS';

export const SET_PENDING_TASKS_CLAIM = 'SET_PENDING_TASKS_CLAIM';
export interface CivilProceedingDoc {
  url: string;
  type: string;
  name: string;
}
export const DOC_ID_REQUEST = '001';
export const DOC_ID_CITATION = '002';
export const DOC_ID_INVITATION = '001';
export const civilProceedingType = [
  'Procédure civile',
  'Procédure commerciale',
  'Procédure corretionnelle',
];
export interface invitationDoc {
  url: string;
  type: string;
  name: string;
}

export const DAMAGE_INIT_STATE: DamageType = {
  otherProperties: false,
  adverseVehicles: false,
};

export const CLAIM_TYPE_INIT_STATE: ClaimType = {
  corporeal: false,
  material: false,
};

export const OTHER_DAMAGE_INIT_STATE: OtherDamage = {
  description: '',
};

export const VEHICLE_FORM_INIT_STATE: VehicleForm = {
  brand: '',
  registrationNumber: '',
  opposingParty: '',
  firstName: '',
  lastName: '',
};

export const VICTIM_FORM_INIT_STATE: VictimForm = {
  id: '',
  firstName: '',
  lastName: '',
  cin: '',
  telephoneNumber: '',
  procedureId: '',
  damageType: '',
  profession: '',
  city: '',
  address: '',
  itt: '',
  claimId: '',
  isExcluded: '',
  workAccidentId: '',
  classKey: '',
  injuryPostKey: '',
  dateOfBirth: null,
  qualityKey: '',
  opposition: '',
  victimKey: '',
  beneficiaries: [],
  gender: '',
  numberOfSpouse: 0,
  numberOfDependents: 0,
  numberOfChildren: 0,
  annualOfIncome: 0,
};

export const RC_CORPOREAL_DAMAGE_CAUSED_TO_THIRD_PARTIES =
  'RC - Dommages corporels causés aux tiers';

export const VEHICLE_FORM_VALUES_INIT_STATE = {};
export const VICTIM_FORM_VALUES_INIT_STATE = {};

export interface ContestationDoc {
  url: string;
  type: string;
  name: string;
}

export const PROVISION_TAB_LABELS = ['Provisions', 'Règlement'];
export const REGULATION_TAB_LABELS = ['Historiques', 'Créer règlement'];
export const REGULATION_TAB_LABELS_CONSULTATION = ['Historiques'];

export const LABEL_INSTANCES = {
  PROVISION: 'PROVISION',
  APPEAL: 'APPEAL',
  FIRST_INSTANCE: 'FIRST_INSTANCE',
};
export const EXPERTISE_ACCOUNTING_ID = 2;
export const EXPERTISE_MECHANIC_ID = 3;
export const EXPERTISE_MEDICAL_ID = 1;
export const DOCTOR_RESERVE = 'Medecin_Reserve';
export const EXPERT_RESERVE = 'Expert_Reserve';
export const DEFAULT_TYPE_CODE = {
  MEDICAL: '7',
  ACCOUNTING: '103',
  MECHANIC: '103',
};
export const expertiseExpertTabsLabels = [
  'Rapport conseil',
  'PV de carence',
  "Reports d'expertise",
];
export const ASSIGNEMENT_EXPERTISE_TYPE = {
  APPRECIATION: 'APPRECIATION',
  ASSIGNEMENT: 'ASSIGNEMENT',
};

export const CLAIM_STATUSES = {
  ACTIVATION: 'Activation',
  INPROGRESS: 'EnCours',
  REOPEN: 'Ré-Ouvert',
  CLOSED: 'Clos',
  FIXED: 'Reglé',
  NOFOLLOWUP: 'Sans suite',
  PREACTIVATION: 'Pré-activation',
  CANCELED: 'Annulé',
};

export const CLAIM_STATUS_OPERATIONS = {
  [CLAIM_STATUSES.REOPEN]: 'ReOpen',
  [CLAIM_STATUSES.CLOSED]: 'Close',
  [CLAIM_STATUSES.NOFOLLOWUP]: 'NoFollowUp',
};

export const CLAIM_STATUS_TRACKING = {
  ReOpen: CLAIM_STATUSES.REOPEN,
  Close: CLAIM_STATUSES.CLOSED,
  NoFollowUp: CLAIM_STATUSES.NOFOLLOWUP,
};
export const JUDICIARY_COLOR_STATUS = {
  PENDING: '#f9be00',
  VALIDATED: '#0ea800',
  REJECTED: '#825474',
};
export const VICTIM_QUALITY_KEYS = {
  Driver: '1',
  Subscriber: '4',
  Owner: '3',
  Pedestrian: '5',
  Cyclist: '6',
  Passenger: '2',
};
export const ListProceeding = [
  {
    id: 1,
    title: 'Procédure commerciale',
  },
  {
    id: 2,
    title: 'Procédure civile',
  },
  {
    id: 3,
    title: 'Procédure correctionelle',
  },
];
